module.exports = __webpack_public_path__ + "img/git.828d86cc.png";